export const ProductNames2026 = [
  { value: 'add', label: '+ Add more products', translationKey: 'addMoreProducts' },
  { value: 'playbase_essentials', translation: 'PlayBase Essentials' },
  { value: 'playbase_plus', translation: 'PlayBase Plus' },
  { value: 'playbase_advanced', translation: 'PlayBase Advanced' },
  { value: 'nexus_prime', translation: 'Nexus Prime' },
  { value: 'nexus_prime_live', translation: 'Nexus Prime + Live' },
  { value: 'nexus_pro', translation: 'Nexus Pro' },
  { value: 'nexus_pro_live', translation: 'Nexus Pro + Live' },
  { value: 'nexus_elite', translation: 'Nexus Elite' },
  { value: 'minutes_10_one_time', translationKey: 'minutes10' },
  { value: 'minutes_100_one_time', translationKey: 'minutes100' },
  {
    value: 'minutes_1000_one_time',
    label: '1.000 Cloud Minutes Pack',
    translationKey: 'minutes1000'
  },
  {
    value: 'minutes_10000_one_time',
    label: '10.000 Cloud Minutes Pack',
    translationKey: 'minutes10000'
  }
]

export const ProductNames2025 = [{ value: 'nexus_elite_2025', translation: 'Nexus Elite' }]

export const ProductNames2024 = [
  { value: 'starter_pause', translation: 'Starter + Pause ∞' },
  { value: 'starter_code', translation: 'Starter + Code ∞' },
  { value: 'starter_code_pause', translation: 'Full Starter' },
  { value: 'essentials', translation: 'Essentials' },
  { value: 'essentials_code', translation: 'Essentials + Code ∞' },
  { value: 'essentials_mft', translation: 'Essentials + MFT' },
  { value: 'essentials_mft_code', translation: 'Full Essentials' },
  { value: 'prime', translation: 'Prime' },
  { value: 'prime_mft', translation: 'Prime + MFT' },
  { value: 'prime_presets', translation: 'Prime + Presets' },
  { value: 'prime_live', translation: 'Prime + Live' },
  { value: 'prime_presets_mft', translation: 'Prime + Presets + MFT' },
  { value: 'prime_presets_live', translation: 'Prime + Presets + Live' },
  { value: 'prime_mft_live', translation: 'Prime + MFT + Live' },
  { value: 'prime_presets_mft_live', translation: 'Full Prime' },
  { value: 'pro_2024', translation: 'Pro' },
  { value: 'pro_2024_live', translation: 'Pro + Live' },
  { value: 'elite_2024', translation: 'Elite' }
]

export const ProductNames2023 = [
  { value: 'student', label: 'Student Plan', translation: 'Student' },
  { value: 'codepad', label: 'Code Plan', translation: 'Code' },
  { value: 'basic', label: 'Basic Plan', translation: 'Basic' },
  { value: 'basic_codepad', label: 'Basic+Code Plan', translation: 'Basic+Code' },
  { value: 'basic_mft', label: 'Basic+MFT Plan', translation: 'Basic+MFT' },
  { value: 'basic_mft_codepad', label: 'Full Basic Plan', translation: 'Full Basic' },
  { value: 'lite', label: 'Lite Plan', translation: 'Lite' },
  { value: 'pro', label: 'Pro Plan', translation: 'Pro' },
  { value: 'elite', label: 'Elite Plan', translation: 'Elite' }
]

// Order matters: newer products must come first so they win any partial product code lookup.
export const ProductNames = [
  ...ProductNames2026,
  ...ProductNames2025,
  ...ProductNames2024,
  ...ProductNames2023
]
